import type { Contact } from '../types/contact'

export type PostalAddress = Pick<Contact, 'street' | 'addressLine2' | 'zipcodeText' | 'cityText' | 'country'>

const isPresent = (part: string | null | undefined): part is string => Boolean(part)

export const getPostalAddressLines = (address: PostalAddress): string[] => {
  const { addressLine2, cityText, country, street, zipcodeText } = address
  const locality = [zipcodeText, cityText].filter(Boolean).join(' ')

  return [street, addressLine2, locality, country?.name].filter(isPresent)
}
